<div class="update-password-component">
  <lib-change-password
    [maxLength]="maxLength"
    [validationParts]="validationParts"
    [labels]="labels">
  </lib-change-password>
</div>
